const splitVersion = function(version: string, separator: string = '.') {
  if (!version) {
    return []
  }

  return version.split(separator)
}

/**
 * 对比版本号
 * @param { String } currentVersion  当前版本号
 * @param { String } compareVersion  需要对比的版本号
 * @param { String } separator 标识符，需要拆分的标识符， 默认 .
 * @returns { Number } 0 小于  1 大于  2 等于
 */
export const compareVersion = function(
  currentVersion: string,
  compareVersion: string,
  // separator?: string
): number {
  const currentArr = splitVersion(currentVersion)
  const compareArr = splitVersion(compareVersion)

  for (let i = 0; i < currentArr.length; i++) {
    const current = Number(currentArr[i])
    const compare = Number(compareArr[i])

    if (current < compare) {
      return 0
    }

    if (current > compare) {
      return 1
    }

    if (i === currentArr.length - 1) {
      if (current === compare) {
        return 2
      }
    }
  }

  return -1
}

/**
 * 判断终端
 */
export const detectVersion = function() {
  let isAndroid: boolean
  let isIOS: boolean
  let isIOS9: boolean
  let version: any
  const u = navigator.userAgent
  const ua = u.toLowerCase()

  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    //android终端或者uc浏览器
    //Android系统
    isAndroid = true
  }

  if (ua.indexOf('like mac os x') > 0) {
    //ios
    const regStr_saf = /os [\d._]*/gi
    const verinfo = ua.match(regStr_saf)
    version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
  }
  const version_str = version + ''
  if (version_str != 'undefined' && version_str.length > 0) {
    version = parseInt(version)
    if (version >= 8) {
      // ios9以上
      isIOS9 = true
    } else {
      isIOS = true
    }
  }

  return { isAndroid, isIOS, isIOS9 }
}

/**
 * 获取url参数
 * @param { String } name 需要获取的参数名称
 * @param { String } url 选填，默认是url
 * @returns { String } 返回参数值
 */
export const getQueryString = function(name: string, url = ''): string {
  let link = location.href
  if (url) link = url
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(link) || ['', ''])[1].replace(
        /\+/g,
        '%20'
      )
    ) || null
  )
}

export function debounce(cb) {
  const time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200
  let timer = null
  return function() {
    const ctx = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function() {
      cb.apply(ctx, args)
    }, time)
  }
}

// 切割数组
export const cuttingArr = (arr, index) => {
  const result = []
  if (!Array.isArray(arr)) {
    return result
  }
  if (arr.length === 0) {
    return []
  }
  if (index < 1) {
    return [arr]
  }
  for (let i = 0; i < arr.length; i += index) {
    result.push(arr.slice(i, i + index))
  }
  return result
}

/**
 * 格式化日期
 * @param {*} fmt YYYY-mm-dd HH:MM:SS
 * @param { Date } date Date格式日期
 * @returns 返回fmt对应的日期字符串
 */
export function dateFormat(fmt: string, date: Date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }
  return fmt
}

// $ 解析url 链接参数
export const getUrlParams = (url) => {
  url = url || window.location.href
  if (url.indexOf('?') < 0) return {}
  return url
    .replace(/^.+?\?/, '')
    .replace(/#.+/, '')
    .split('&')
    .filter((param) => param)
    .reduce((obj, param) => {
      const i = param.indexOf('=')
      const t = [param.slice(0, i), param.slice(i + 1)]
      obj[t[0]] = decodeURIComponent(t[1]) // 对url中的值进行解码（对齐vue-router内部的处理）
      return obj
    }, {})
}

export const toParams = (param) => {
  let result = ''
  for (const name in param) {
    if (typeof param[name] != 'function') {
      result += '&' + name + '=' + encodeURI(param[name])
    }
  }
  return result.substring(1)
}

export const getRouteTag = () => {
  const origin = location.origin
  const regex1 = /-[^.]+\.sand/;
  const regex2 = /-[^.]+\.test/;
  const sand = origin.match(regex1);
  const test = origin.match(regex2);
  if (sand) {
    return sand[0]
  }
  if (test) {
    return test[0]
  }
  return ''
}
